<template>
<!-- 全景直播 -->
    <div class="PanoramicLive">
        <PanoramicLiveHeader></PanoramicLiveHeader>
        <PanoramicLiveCan></PanoramicLiveCan>
        <PanoramicLiveFeatures></PanoramicLiveFeatures>
        <PanoramicLiveDisplay></PanoramicLiveDisplay>
        <PanoramicLiveCase @handleChange="changeName"></PanoramicLiveCase>
        <paheFooter></paheFooter>
        <popUpwindow v-if="popUp_" :lin_k="link_" :codeid="codeid"   @close1="close1"></popUpwindow>
    </div>
</template>
<script>
import PanoramicLiveHeader from '@/common/PanoramicLive/PanoramicLive-header'
import PanoramicLiveCan from '@/common/PanoramicLive/PanoramicLive-can'
import PanoramicLiveFeatures from '@/common/PanoramicLive/PanoramicLive-Features'
import PanoramicLiveDisplay from '@/common/PanoramicLive/PanoramicLive-display'
import PanoramicLiveCase from '@/common/PanoramicLive/PanoramicLive_case'
//引入底部
import paheFooter from '@/common/index/pahe-footer'
//引入案例弹窗
import popUpwindow from '@/common/public/pop-upwindow'
export default {
    name:"PanoramicLive",
    data(){
        return {
            popUp_:false,
            link_:null,
            codeid:null,
            Pop_up_data:[
            
            ],
            cate2:null
        }
    },
    components:{
        PanoramicLiveHeader,
        PanoramicLiveCan,
        PanoramicLiveFeatures,
        PanoramicLiveDisplay,
        PanoramicLiveCase,
        paheFooter,
        popUpwindow
    },
    mounted() {
        var PanoramicLive = localStorage.getItem('PanoramicLive');
        document.documentElement.scrollTop = PanoramicLive;
    },
    methods:{
        changeName(link_){
            this.link_=link_.cate
            this.codeid=link_.ID
            this.popUp_ = true
            
        },
        close1(){
             this.popUp_ = false
        }
    },
    destroyed() {
        let i1 = document.documentElement.scrollTop;
        localStorage.setItem('PanoramicLive', i1)
    },
}
</script>
<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/PanoramicLive.vue